if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;



	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
"src_containers_Payments_js": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var extractCssOldTags = [];
var extractCssNewTags = [];
var extractCssApplyHandler = function (options) {
	return {
		dispose: function () {},
		apply: function () {
			for (var i = 0; i < extractCssNewTags.length; i++) extractCssNewTags[i].sheet.disabled = false;
			for (var i = 0; i < extractCssOldTags.length; i++) {
				var oldTag = extractCssOldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			extractCssOldTags.length = 0;
			extractCssNewTags.length = 0;
		}
	}
}
var extractCssInitialChunkIds = {"index": 1,"npm-ace-builds": 1,"npm-add-to-calendar-button-react": 1,"npm-assert": 1,"npm-autosuggest-highlight": 1,"npm-axios": 1,"npm-babel-runtime": 1,"npm-babel_runtime": 1,"npm-classnames": 1,"npm-clsx": 1,"npm-core-js": 1,"npm-css-vendor": 1,"npm-d3-array": 1,"npm-d3-color": 1,"npm-d3-format": 1,"npm-d3-interpolate": 1,"npm-d3-path": 1,"npm-d3-scale": 1,"npm-d3-shape": 1,"npm-d3-time": 1,"npm-d3-time-format": 1,"npm-decimal.js-light": 1,"npm-diff-match-patch": 1,"npm-draft-js": 1,"npm-draftjs-to-html": 1,"npm-emotion_cache": 1,"npm-emotion_hash": 1,"npm-emotion_is-prop-valid": 1,"npm-emotion_memoize": 1,"npm-emotion_react": 1,"npm-emotion_serialize": 1,"npm-emotion_sheet": 1,"npm-emotion_styled": 1,"npm-emotion_unitless": 1,"npm-emotion_use-insertion-effect-with-fallbacks": 1,"npm-emotion_utils": 1,"npm-emotion_weak-memoize": 1,"npm-eventemitter3": 1,"npm-fast-equals": 1,"npm-fbjs": 1,"npm-history": 1,"npm-hoist-non-react-statics": 1,"npm-html-to-draftjs": 1,"npm-hyphenate-style-name": 1,"npm-immutable": 1,"npm-inherits": 1,"npm-internmap": 1,"npm-invariant": 1,"npm-is-buffer": 1,"npm-is-in-browser": 1,"npm-jss": 1,"npm-jss-plugin-camel-case": 1,"npm-jss-plugin-default-unit": 1,"npm-jss-plugin-global": 1,"npm-jss-plugin-nested": 1,"npm-jss-plugin-props-sort": 1,"npm-jss-plugin-rule-value-function": 1,"npm-jss-plugin-vendor-prefixer": 1,"npm-linkify-it": 1,"npm-lodash": 1,"npm-mdi-material-ui": 1,"npm-mui_icons-material": 1,"npm-mui_material": 1,"npm-mui_private-theming": 1,"npm-mui_styled-engine": 1,"npm-mui_styles": 1,"npm-mui_system": 1,"npm-mui_utils": 1,"npm-object-assign": 1,"npm-popperjs_core": 1,"npm-prop-types": 1,"npm-react": 1,"npm-react-ace": 1,"npm-react-async-script": 1,"npm-react-avatar-editor": 1,"npm-react-confetti": 1,"npm-react-dom": 1,"npm-react-draft-wysiwyg": 1,"npm-react-fast-compare": 1,"npm-react-ga4": 1,"npm-react-google-recaptcha": 1,"npm-react-helmet-async": 1,"npm-react-is": 1,"npm-react-linkify": 1,"npm-react-redux": 1,"npm-react-refresh": 1,"npm-react-share": 1,"npm-react-smooth": 1,"npm-react-transition-group": 1,"npm-recharts": 1,"npm-recharts-scale": 1,"npm-redux": 1,"npm-redux-thunk": 1,"npm-regexparam": 1,"npm-resolve-pathname": 1,"npm-rspack_core": 1,"npm-rspack_plugin-react-refresh": 1,"npm-scheduler": 1,"npm-setimmediate": 1,"npm-shallowequal": 1,"npm-stylis": 1,"npm-tiny-invariant": 1,"npm-tiny-warning": 1,"npm-tlds": 1,"npm-ua-parser-js": 1,"npm-uc.micro": 1,"npm-use-sync-external-store": 1,"npm-util": 1,"npm-value-equal": 1,"npm-victory-vendor": 1,"npm-wouter": 1,"vendors-node_modules_react-draft-wysiwyg_dist_react-draft-wysiwyg_css": 1,};
// A chunk is present on this page only when the active JavaScript
// chunk-loading runtime records it as fully loaded.
var extractCssChunkIsLoaded = function (chunkId) {
	return typeof __webpack_require__.hmrS_jsonp !== "undefined" && __webpack_require__.hmrS_jsonp && __webpack_require__.hmrS_jsonp[chunkId] === 0;
};
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList, css, miniCss) {
	applyHandlers.push(extractCssApplyHandler);
	/**
		`miniCss` is the hot-update manifest's namespace for extracted CSS:
		`miniCss.c` lists the chunks whose extracted CSS content actually changed
		and `miniCss.r` the chunks whose extracted CSS disappeared. It is kept
		apart from the native css runtime's `css` namespace so neither runtime
		reacts to the other's stylesheets. Its absence means this update carries
		no extracted CSS work at all — notably the runtime chunk is in `chunkIds`
		on every update (its full hash always changes) while its stylesheet
		rarely does.
	 */
	var cssRemovedChunkIds = (miniCss && miniCss.r) || [];
	var cssChunkIds = (miniCss && miniCss.c) || [];
	var seen = {};
	cssRemovedChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var oldTag = extractCssFindStylesheet(href, __webpack_require__.p + href);
		if (oldTag) extractCssOldTags.push(oldTag);
	});
	cssChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var fullhref = __webpack_require__.p + href;
		if (seen[fullhref]) return;
		seen[fullhref] = true;
		var oldTag = extractCssFindStylesheet(href, fullhref);
		// The manifest is computed from the compilation and also lists chunks this
		// page never loaded. A missing tag is legitimate only for a chunk that is
		// actually on the page: an initial chunk gaining its first stylesheet, or
		// a loaded async chunk whose stylesheet was removed by an earlier update.
		if (!oldTag && !extractCssInitialChunkIds[chunkId] && !extractCssChunkIsLoaded(chunkId)) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = extractCssCreateStylesheet(
				chunkId,

				/**
					Use a query to bypass the browser cache: with an existing link the
					browser may treat the new tag as the same resource and skip fetching
					(this can happen during lazy compilation, same strategy as the
					updateCss API), and even without a current link the stable filename
					may still be cached from before the stylesheet was removed.
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.sheet.disabled = true;
					if (oldTag) extractCssOldTags.push(oldTag);
					extractCssNewTags.push(tag);
					resolve();
				},
				reject
			);
		}))
	});
}

// no prefetch
// no preload